import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { tS } from "../../services/translation.service";

export const InfoEmailScreen = () => {
  const [language, setLanguage] = useState(0);
  const params = useParams();

  useEffect(() => {
      if (params?.language && !language) {
        setLanguage(getLanguageValue(params?.language));
      }
    }, [params, language]);

  const getLanguageValue = (language: string) => {
    if(language === 'de') {
      return 0;
    }else if(language == 'en') {
      return 1;
    } else if(language == 'sk') {
      return 2;
    } else {
      return 0;
    }
  }


  return (
    <div className="container">
      <p>
        {tS.gT(tS.P.BookingSuccessfullyCompleted, language)}<br/>
        {tS.gT(tS.P.YouWillReceiveEmail, language)}<br/>
      {tS.gT(tS.P.AddressYouSupplied, language)}</p>

      <p>{tS.gT(tS.P.EmailContainsPickUpCode, language)}<br/>
      {tS.gT(tS.P.AnExplanationOfUsage, language)}</p>
    </div>
  );
};
